import {useContext, useEffect, useState} from 'react'
import _ from 'lodash'
import WindowedSelect from 'react-windowed-select'
import {DataSourcesContext, IDataSourceItem} from '../..'

export interface IDataSourceItemSelectProps {
  value?: IDataSourceItem
  onSelect?: (item: IDataSourceItem) => void
}

interface IDropdownItem {
  label: string
  value: IDataSourceItem
}

export function DataSourceItemSelect(props: IDataSourceItemSelectProps) {
  const {value, onSelect} = props

  const {mergedItems} = useContext(DataSourcesContext)

  const [dropdownOptions, setDropdownOptions] = useState<IDropdownItem[]>([])

  useEffect(() => {
    setDropdownOptions(
      _.chain(mergedItems)
        .map(
          (item) =>
            ({
              label: item.title,
              value: item,
            }) as IDropdownItem
        )
        .value()
    )
  }, [mergedItems])

  function handleOnChange(data: unknown) {
    if (!onSelect) return
    const value = _.get(data as IDropdownItem, 'value')
    onSelect(value)
  }

  return (
    <WindowedSelect
      isSearchable
      captureMenuScroll
      autoFocus
      defaultMenuIsOpen
      placeholder='add title...'
      menuPlacement='bottom'
      closeMenuOnSelect={false}
      windowThreshold={50}
      options={dropdownOptions}
      styles={{
        menu: (provided) => ({
          ...provided,
          zIndex: 1000,
        }),
        option: (provided, state) => ({
          ...provided,
          borderBottom: '1px dotted pink',
          color: state.isFocused ? 'white' : 'black',
          background: state.isFocused ? '#ff099a' : 'transparent',
        }),
      }}
      value={value}
      onChange={handleOnChange}
    />
  )
}
